import { Value } from '@coveo/bueno';
import { requiredNonEmptyString, validatePayload, } from '../../../utils/validate-payload.js';
import { makeAnalyticsAction, } from '../../analytics/analytics-utils.js';
import { SearchPageEvents } from '../../analytics/search-action-cause.js';
import { facetIdDefinition } from '../generic/facet-actions-validation.js';
import { buildFacetBaseMetadata, buildFacetSelectionChangeMetadata, getStateNeededForFacetMetadata, } from './facet-set-analytics-actions-utils.js';
export const logFacetShowMore = (facetId) => makeAnalyticsAction('analytics/facet/showMore', (client, state) => {
    validatePayload(facetId, facetIdDefinition);
    const metadata = buildFacetBaseMetadata(facetId, getStateNeededForFacetMetadata(state));
    return client.makeFacetShowMore(metadata);
});
export const logFacetShowLess = (facetId) => makeAnalyticsAction('analytics/facet/showLess', (client, state) => {
    validatePayload(facetId, facetIdDefinition);
    const metadata = buildFacetBaseMetadata(facetId, getStateNeededForFacetMetadata(state));
    return client.makeFacetShowLess(metadata);
});
//TODO: KIT-2859
export const logFacetUpdateSort = (payload) => makeAnalyticsAction('analytics/facet/sortChange', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        criterion: new Value({
            required: true,
        }),
    });
    const { facetId, criterion } = payload;
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const base = buildFacetBaseMetadata(facetId, stateForAnalytics);
    const metadata = { ...base, criteria: criterion };
    return client.makeFacetUpdateSort(metadata);
});
//TODO: KIT-2859
export const logFacetClearAll = (facetId) => makeAnalyticsAction('analytics/facet/reset', (client, state) => {
    validatePayload(facetId, facetIdDefinition);
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const metadata = buildFacetBaseMetadata(facetId, stateForAnalytics);
    return client.makeFacetClearAll(metadata);
});
//TODO: KIT-2859
export const logFacetSelect = (payload) => makeAnalyticsAction('analytics/facet/select', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        facetValue: requiredNonEmptyString,
    });
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const metadata = buildFacetSelectionChangeMetadata(payload, stateForAnalytics);
    return client.makeFacetSelect(metadata);
});
//TODO: KIT-2859
export const logFacetExclude = (payload) => makeAnalyticsAction('analytics/facet/exclude', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        facetValue: requiredNonEmptyString,
    });
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const metadata = buildFacetSelectionChangeMetadata(payload, stateForAnalytics);
    return client.makeFacetExclude(metadata);
});
//TODO: KIT-2859
export const logFacetDeselect = (payload) => makeAnalyticsAction('analytics/facet/deselect', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        facetValue: requiredNonEmptyString,
    });
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const metadata = buildFacetSelectionChangeMetadata(payload, stateForAnalytics);
    return client.makeFacetDeselect(metadata);
});
//TODO: KIT-2859
export const logFacetUnexclude = (payload) => makeAnalyticsAction('analytics/facet/unexclude', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        facetValue: requiredNonEmptyString,
    });
    const stateForAnalytics = getStateNeededForFacetMetadata(state);
    const metadata = buildFacetSelectionChangeMetadata(payload, stateForAnalytics);
    return client.makeFacetUnexclude(metadata);
});
//TODO: KIT-2859
export const logFacetBreadcrumb = (payload) => makeAnalyticsAction('analytics/facet/breadcrumb', (client, state) => {
    validatePayload(payload, {
        facetId: facetIdDefinition,
        facetValue: requiredNonEmptyString,
    });
    const metadata = buildFacetSelectionChangeMetadata(payload, getStateNeededForFacetMetadata(state));
    return client.makeBreadcrumbFacet(metadata);
});
// --------------------- KIT-2859 : Everything above this will get deleted ! :) ---------------------
export const facetClearAll = () => {
    return {
        actionCause: SearchPageEvents.facetClearAll,
    };
};
export const facetSelect = () => ({
    actionCause: SearchPageEvents.facetSelect,
});
export const facetExclude = () => ({
    actionCause: SearchPageEvents.facetExclude,
});
export const facetDeselect = () => ({
    actionCause: SearchPageEvents.facetDeselect,
});
export const facetUnexclude = () => ({
    actionCause: SearchPageEvents.facetUnexclude,
});
export const breadcrumbFacet = () => ({
    actionCause: SearchPageEvents.breadcrumbFacet,
});
